<style scoped>
    .expense-group-container{
        /*position: relative;*/
    }
    .search-input{
        display: inline-block;
        min-width: 250px;
        max-width: 600px;
    }
    .header{
        display: inline-block;
        vertical-align: middle;
        font-size: 24px;
    }
    table{
        border-collapse:collapse;
    }
    table tr{
        border-bottom: 1px solid #dddee1;
    }
    table th, table td{
        border-right: 1px solid #dddee1;
    }
</style>
<template>
  <div class="expense-group-container">
    <div class="line text-center">
      <span class="header">付款/报销 </span>
      <div class="search-input">
        <Input
          v-model="params.search"
          placeholder="输入关键字搜索"
          @on-enter="doSearch"
        />
      </div>
      <Ajaxbtn
        ref="searchBtn"
        :url="get_my_expense_groups_path"
        :params="params"
        type="search"
        @done="handleExpenseGroupData"
        @fail="handleExpenseGroupFail"
      />
    </div>
    <div class="list-container">
      <Table
        :columns="expense_group_columns"
        :data="expense_groups"
        :no-data-text="empty_tip"
      />
      <Backdrop v-show="loading" />
      <div class="line">
        点击左侧箭头可查看详细信息
      </div>
    </div>

    <div
      v-show="page_info.total"
      class="line paginate-fix-bottom"
    >
      <Page
        show-total
        show-elevator
        :current="page_info.current"
        :total="page_info.total"
        :page-size="page_info.page_size"
        @on-change="pageChange"
      />
    </div>
  </div>
</template>
<script :route="{path: '/mine/expense', noChkout: true}">
  import Util from '../../libs/util';
  import ExpenseExpand from './components/expense_expand';
  import {mapGetters} from "vuex";
  export default {
    /* router_info_start */
    router_info: {
      path: '/mine/expense',
      noChkout: true
    },
    /* router_info_end */

    components: { ExpenseExpand },
    data() {
      return {
        get_my_expense_groups_path: Util.api.query_my_expense_group,
        loading: false,
        empty_tip: '获取数据中...',
        params: {
          per_page: 10,
          page: 1,
          search: '',
          team_id: '0',
          company_id: '0',
          payment_type: this.type,
        },
        page_info: {
          current: 1,
          total: 0,
          page_size: 10
        },
        companies: [],
        companies_hash: {},
        teams: [],
        teams_hash: {},
        jobs: [],
        jobs_hash: {},
        status_hash: {
          0: '待财务审核',
          5: '财务已审核, 待付款',
          9: '已完成'
        },
        show_editor: false,
        expense_groups: [],
        expense_group_columns: [
          {
            type: 'expand',
            width: 40,
            render: (h, params) => {
              return h(ExpenseExpand, {
                props: {
                  type: this.type,
                  expenseGroup: params.row,
                  expenseTypeHash: this.expense_type_hash
                }
              })
            }
          },
          {
            title: '编号',
            key: 'uid',
            width: 170,
            render: (h, params) => {
              const row = params.row;
              const ret = [];
              ret.push(h('div', {
                'class': {
                  'color-error': row.del
                }
              }, row.uid));
              if (row.del) {
                ret.push(h('div', {
                  'class': {
                    'color-error': true
                  }
                }, '已废弃'));
              }
              if (row.advance_id) {
                ret.push(h('div', '[冲预支]'));
              }
              return h('div', ret);
            }
          },
          {
            title: '类别',
            width: 50,
            render: (h, params) => {
              const row = params.row;
              const type = row.payment_type === 1 ? '付款' : '报销';
              return h('div', type);
            }
          },
          {
            title: '名称',
            key: 'name'
          },
          {
            title: '公司-团队',
            render: (h, params) => {
              let company = '未设置';
              if (this.companies_hash[params.row.company_id]) {
                company = this.companies_hash[params.row.company_id].short_name;
              }
              let team = '未设置';
              if (this.teams_hash[params.row.team_id]) {
                team = this.teams_hash[params.row.team_id].name;
              }
              const ret = [];
              ret.push(h('div', {
                'class':{
                  'text-bold': true
                },
              }, company));
              ret.push(h('div', team));
              return h('div', ret);
            }
          },
          {
            title: '申请人',
            width: 60,
            key: 'apply_user',
            render: (h, params) => {
              const row = params.row;
              const ret = [];
              ret.push(h('div', row.apply_user));
              return h('div', ret);
            }
          },
          {
            title: '付款对象',
            render: (h, params) => {
              const ret = params.row.payee_user || params.row.payee_company;
              return h('div', ret);
            }
          },
          {
            title: '付款总金额',
            align: 'right',
            width: 100,
            key: 'total_price',
            render: (h, params) => {
              const ret = [];
              ret.push(h('Icon', {
                props: {
                  type: 'logo-yen'
                }
              }));
              ret.push(h('span', ' ' + math.eval(params.row.total_price).toFixed(2) + ' '));
              return h('div', {
                'class': {
                  'text-right': true
                }
              }, ret);
            }
          },
          {
            title: '状态',
            width: 160,
            key: 'status',
            render: (h, params) => {
              const row = params.row;
              const status_text = this.status_hash[row.status];
              const ret = [];
              ret.push(h('div', [
                h('span', {}, '填写: '),
                h('span', {}, row.fill_user),
                h('span', {
                  'class': {
                    'color-grey': true
                  }
                }, ' ' + moment(row.created_at).format('YYYY-MM-DD')),
              ]));
              if (row.status === 0) {
                ret.push(h('span', {
                  'class': {
                    'color-info': true
                  }
                }, '待财务审核'));
              }
              if (row.status === 5) {
                ret.push(h('div', [
                  h('span', {}, '审核: '),
                  h('span', {}, row.verify_user),
                  h('span', {
                    'class': {
                      'color-grey': true
                    }
                  }, ' ' + moment(row.verified_at).format('YYYY-MM-DD')),
                ]));
                ret.push(h('div', [
                  h('span', {
                    'class': {
                      'color-info': true
                    }
                  }, '待付款'),
                ]));
              }
              if (row.status === 9) {
                ret.push(h('div', [
                  h('span', {}, '审核: '),
                  h('span', {}, row.verify_user),
                  h('span', {
                    'class': {
                      'color-grey': true
                    }
                  }, ' ' + moment(row.verified_at).format('YYYY-MM-DD')),
                ]));
                ret.push(h('div', [
                  h('span', {
                    'class': {
                      'color-success': true
                    }
                  }, '完成: '),
                  h('span', {}, row.finish_user),
                  h('span', {
                    'class': {
                      'color-grey': true
                    }
                  }, ' ' + moment(row.finished_at).format('YYYY-MM-DD')),
                ]));
              }
              return h('div', ret);
            }
          }
        ],
        expense_types: [],
        expense_type_hash: {},
      }
    },
    computed: {
      cur_customer() {
        return this.$store.state.cur_customer;
      },
      ...mapGetters({
        companies: 'async/companies',
        companies_hash: 'async/companies_hash',
        teams: 'async/root_teams',
        teams_hash: 'async/root_teams_hash',
        jobs: 'async/jobs',
        jobs_hash: 'async/jobs_hash',
        offices: 'async/offices',
        offices_hash: 'async/offices_hash',
      })
    },
    created() {
      this.init();
    },
    mounted() {
      //
    },
    methods: {
      init() {
        this.edit_expense_group = this.new_expense_group;
        this.getExpenseTypes();
        this.getExpenseGroups();
      },
      getExpenseTypes() {
        Util.ajax.get(Util.api.get_expense_types).then((response) => {
          return response.data;
        }).then((res) => {
          if (res.code === 1) {
            const data = res.data;
            this.handleExpenseTypes(data);
          } else {
            this.$Modal.error({
              title: '错误',
              content: res.msg
            });
          }
        }).catch((e) => {
          console.log(e);
        });
      },
      handleExpenseTypes(expense_types) {
        expense_types.forEach((expense_type) => {
          if (expense_type.parent_id) {
            expense_type.name = this.expense_type_hash[expense_type.parent_id].name + '-' + expense_type.name;
          }
          this.expense_type_hash[expense_type.id] = expense_type;
          this.expense_types.push(expense_type);
          if (expense_type.expense_types.length) {
            this.handleExpenseTypes(expense_type.expense_types);
          }
        });
      },
      getExpenseGroups() {
        if (!this.loading) {
          this.loading = true;
          this.empty_tip = '获取数据中...';
          Util.ajax.get(Util.api.query_my_expense_group, {
            params: this.params
          }).then((response) => {
            return response.data;
          }).then((res) => {
            if (res.code === 1) {
              const data = res.data;
              this.handleExpenseGroupData(data);
            } else {
              this.$Modal.error({
                title: '错误',
                content: res.msg
              });
            }
          }).catch((e) => {
            this.loading = false;
            this.empty_tip = '获取数据失败, 请刷新页面重试';
            console.log(e);
          });
        }
      },
      pageChange(new_page) {
        this.params.page = new_page;
        this.getExpenseGroups();
      },
      doSearch() {
        this.$refs.searchBtn.doAjax();
      },
      handleExpenseGroupData(data) {
        this.loading = false;
        this.expense_groups = [];
        data.expense_groups.forEach((expense_group) => {
          this.expense_groups.push(expense_group);
        });
        if (data.expense_groups.length === 0) {
          this.empty_tip = '没有结果, 请重试!';
        }
        this.page_info.current = data.cur_page;
        this.page_info.page_size = data.per_page;
        this.page_info.total = data.total_count;
      },
      handleExpenseGroupFail(e) {
        this.$Message.error('获取失败: ' + e);
        console.log(e);
      },
      getCompanyNameById(id) {
        const company = this.companies_hash[id];
        return company ? company.name : '';
      },
      getTeamNameById(id) {
        const team = this.teams_hash[id];
        return team ? team.name : '';
      },
      getFillTime(edit_expense_group) {
        const time = edit_expense_group.created_at || new Date();
        return moment(time).format('YYYY-MM-DD');
      },
      getTotalInvoicePrice(expense_group) {
        let total = 0;
        expense_group.expenses.forEach((expense) => {
          const invoice_price = expense.invoice_price || 0;
          total = math.eval(total + '+' + invoice_price);
        });
        return total.toFixed(2);
      },
      getTotalPrice(expense_group) {
        let total = 0;
        expense_group.expenses.forEach((expense) => {
          const price = expense.price || 0;
          total = math.eval(total + '+' + price);
        });
        return total.toFixed(2);
      },
      getExpenseTypeName(id) {
        return id ? this.expense_type_hash[id].name : '';
      },
      scanBarcode(expense, key) {
        eventHub.$emit('show-qr-scaner', (data) => {
          expense[key] = data;
        });
      }
    }
  }
</script>
